import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography, Box, useTheme } from '@mui/material'
import { Controller, useForm, FormProvider } from "react-hook-form";

// import { identityValFunctions } from './IdentityValFunctions'
import { InputField, UseImage, CustomLoadingOverlay, GenericContainer, Buttons, GeoLocationGeneric,GenericContainerForm } from '../../components'
import { fileActions, documentsActions, workflowActions,addTitleLegoCurrent } from '../../store/actions'
//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './IdentityValidationStyles'
import { coreFunctions } from '../../utils';
import noFingerImg from '../../assets/noFinger.svg'
import { useTranslation } from 'react-i18next';

export default function SkipJustification(props) {
    const formMethods = useForm({ mode: "onChange" });
    const { control, handleSubmit, register, formState, watch } = useForm({ mode: "onBlur" });
const rdControlsWatch = watch("rdOptions")

    const theme = useTheme()
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [section, setSection] = useState(0)
    const [sections, setSections] = useState([])
    const [justification, setJustification] = useState('')

    const [activeGeolocation, setActiveGeolocation] = useState(true)
    const [latitude, setLatitude] = useState("")
    const [longitude, setLongitude] = useState("")
    const [loadStatusStage, setLoadStatusStage] = useState(false)
    const [isFlowGroup, setIsFlowGroup] = useState(false)

    const file = useSelector(state => state.FileInfo)
    // const uploadSecDoc = useSelector(state => state.UploadSections)
    const uploadMinData = useSelector(state => state.UploadMinutiaData)
    const registroStatusStage = useSelector(state => state.RegStatusStage)

    const folioId = location.state.folioId
    const actorId = location.state.actorId
    const { t } = useTranslation();

    const Options = [
        { Label: 'Discapacidad física', Value: 'Discapacidad física' },
        { Label: 'Falta de extremidad', Value: 'Falta de extremidad' },
        { Label: 'Marca de nacimiento', Value: 'Marca de nacimiento' }
    ]

    let handleBack = () => {
        const nextComponent = 'FingerSelectCapture'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
    }

    useEffect(() => {
        dispatch(addTitleLegoCurrent("No capturar huellas de ambas manos"))
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        let varFlowGroup = sessionStorage.getItem('isFlowGroup')
        setIsFlowGroup(varFlowGroup)
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && file.items?.Stage != undefined) {
            let actGeoloc = file.items.Stage.Properties.find(item => item.Name == "ActiveGeolocation")?.Value
            console.log("actGeoloc-----PARAM--- CONFIG------ ", actGeoloc)
            setActiveGeolocation(actGeoloc === undefined ? true : actGeoloc)

            if (file.items.Stage.DocumentalCategory != undefined && file.items.Stage.DocumentalCategory != null) {
                const secs = file.items.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes[0].Sections
                const ids = secs.filter((sec) => sec.CaptureType == "Minutiae").map((seccion) => seccion.Id)
                setSections(ids)
            }
            if (file.items.Product == "Solicitud Grupal") {
                setIsFlowGroup(true)
            }
        }
    }, [file])

    const sendSection = (data) => {
        console.log("data**********: ", data)
        setLoadView(true)
        const dataToSend = {
            B64Content: null,
            FileId: folioId,
            Actor_Id: actorId,
            SkipActor: (isFlowGroup ? null : true),
            SectionId: sections[section],
            Extension: null,
            Skip: true,
            SkipReason: data["rdOptions"]
        }

        console.log("-----Response upload minutie----- dataToSend...", dataToSend)
        dispatch(documentsActions.UploadMinutiae(dataToSend))
    }

    useEffect(() => {
        console.log("uploadMinData.items------------ :", loadView, section, uploadMinData.items)
        // if (uploadMinData.items != undefined && uploadMinData.items?.Result != undefined && loadView) {
        if (uploadMinData.items != undefined && loadView) {
            // console.log("uploadMinData.items----**********-------- :", loadView, uploadMinData.items)
            // if (uploadMinData.items.Result?.Id != null || uploadMinData.items.Result?.Id != undefined) {
            //     setSection(section + 1)
            // } else {
            setSection(section + 1)
            // }
        } else if (uploadMinData.error != undefined && loadView) {
            alert(uploadMinData.error)
            setLoadView(false)
        }
    }, [uploadMinData])

    useEffect(() => {
        console.log("Section**********: ", section)
        if (section === 1) {
            sendSection({ rdOptions: rdControlsWatch })
        } else if (section > 1) {
            dispatch(workflowActions.RegisterStatusStage({
                File_id: folioId,
                Status: "CargaMinucias"
            }))
            setLoadStatusStage(true)
            // const nextComponent = 'ExternalValidations'
            // identityValFunctions.nextIndocLoading({ navigate, nextComponent, folioId })
        }
    }, [section])

    useEffect(() => {
        console.log("registroStatusStage.items------- ", registroStatusStage.items)
        if (registroStatusStage.items != undefined && registroStatusStage.items != null && loadStatusStage) {
            setLoadStatusStage(false)
            // let folioId = folioId           

            const nextComponent = 'ExternalValidations'
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
        }
    }, [registroStatusStage])

    return (<GenericContainer>
        <FormProvider {...formMethods} >
            <GenericContainerForm>
                {activeGeolocation &&
                    <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
                        console.log("succes,latitude, longitude ", latitude, longitude);
                        setLatitude(latitude);
                        setLongitude(longitude);
                    }}
                        ErrorFN={(error) => console.log('error', error)}
                    />
                }
                {/* <Typography variant="h6" ><b>No capturar huellas de ambas manos</b></Typography> */}
                <UseImage src={noFingerImg} className={localStyles.imgFinger} id='noFingerImg' />
                <Typography variant="subtitle1" >Selecciona el motivo por el cual no se realizará la captura de huellas dactilares.</Typography>

                <InputField
                    inputType="radio"
                    control={control}
                    name='rdOptions'
                    radioValues={Options}
                    validations={{ required: true }}
                    error={!!formState.errors['rdOptions']}
                    helperText={formState.errors['rdOptions']?.message}
                    required={true}
                />
            </GenericContainerForm>
            <Buttons
                ConfirmButtonText='No capturar ambas manos'
                onClickConfirm={handleSubmit(sendSection)}
                CancelButtonText={t("general_cancel")}
                onClickCancel={handleBack} />

            {loadView ?
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                : null}
        </FormProvider >
    </GenericContainer>);
}